import './App.css';
import { Route, Switch } from 'react-router';
import React from 'react';
import Footer from './components/footer/footer';
import About from './views/about/About';
import Armchair from './views/armchair/Armchair';
import Cam from './views/cam/Cam';
import Contacts from './views/contacts/Contacts';
import Drivers from './views/drivers/Drivers';
import Gamepads from './views/gamepads/Gamepads';
import Headphone from './views/headphone/Headphone';
import Keyboards from './views/keyboards/Keyboards';
import Laptopcold from './views/laptopcold/Laptopcold';
import Mice from './views/mice/Mice';
import Mousepads from './views/mousepads/Mousepads';
import NotFound from './views/notFound/NotFound';
import Main from './views/main/Main';
import Triggers from './views/triggers/Triggers';
import ProductDetailPageView from './views/ProductDetailPageView';
import AppBar from './components/AppBar/AppBar';
import SearchPage from './views/searchPage/SearchPage';
// import Container from './components/Container/Container';
import s from './components/AppBar/AppBar.module.css';
import LegalDocuments from './views/legalDocuments/LegalDocuments';
import Certificates from './views/certificates/Certificates';

const App = () => {
  return (
    <>
      <header>
        <AppBar className={s.header} />
      </header>
      <main>
        <Switch>
          <Route exact path="/">
            <Main />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route exact path="/armchair">
            <Armchair />
          </Route>
          <Route exact path="/cam">
            <Cam />
          </Route>
          <Route exact path="/contacts">
            <Contacts />
          </Route>
          <Route path="/searchpage">
            <SearchPage />
          </Route>
          <Route exact path="/triggers">
            <Triggers />
          </Route>
          <Route exact path="/drivers">
            <Drivers />
          </Route>
          <Route exact path="/gamepads">
            <Gamepads />
          </Route>
          <Route exact path="/headphone">
            <Headphone />
          </Route>
          <Route exact path="/keyboards">
            <Keyboards />
          </Route>
          <Route exact path="/laptopcold">
            <Laptopcold />
          </Route>
          <Route exact path="/mice">
            <Mice />
          </Route>
          <Route exact path="/mousepads">
            <Mousepads />
          </Route>
          <Route exact path="/legalDocuments">
            <LegalDocuments />
          </Route>
          <Route exact path="/certificates">
            <Certificates />
          </Route>
          <Route path="/:product/:productId">
            <ProductDetailPageView />
          </Route>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </main>
      <Footer />
    </>
  );
};
export default App;
